/* eslint-disable */
export const initPlayVideo = () => {
	const videoItems = document.querySelectorAll(".video-item");

	if (!videoItems || videoItems.length === 0) return;

	const stopAllVideos = (excludeItem = null) => {
		videoItems.forEach((item) => {
			if (item === excludeItem) return; // bỏ qua video hiện tại

			const thumbnailOverlay = item.querySelector(".video-thumbnail-overlay");
			const videoEmbed = item.querySelector(".video-embed");
			const iframe = item.querySelector(".video-iframe");

			if (iframe && videoEmbed) {
				// Reset về URL gốc
				const originalUrl = iframe.dataset.videoUrl;
				iframe.src = originalUrl || "about:blank";
				videoEmbed.classList.add("hidden"); // ẩn iframe
				if (thumbnailOverlay) thumbnailOverlay.classList.remove("hidden"); // hiện lại overlay
			}
		});
	};

	videoItems.forEach((item) => {
		const playButton = item.querySelector(".play-button");
		const thumbnailOverlay = item.querySelector(".video-thumbnail-overlay");
		const videoEmbed = item.querySelector(".video-embed");
		const iframe = item.querySelector(".video-iframe");

		if (!playButton || !iframe || !videoEmbed) return;

		playButton.addEventListener("click", (e) => {
			e.stopPropagation();

			const videoUrl = iframe?.src || iframe.dataset.videoUrl; // lấy URL từ data hoặc src
			if (!videoUrl) return;

			// 1. Dừng tất cả video khác
			stopAllVideos(item);

			// 2. Ẩn overlay
			if (thumbnailOverlay) thumbnailOverlay.classList.add("hidden");

			// 3. Hiện container iframe
			videoEmbed.classList.remove("hidden");

			// 4. Play video
			iframe.src = videoUrl.includes("autoplay=1")
				? videoUrl
				: `${videoUrl}?autoplay=1&rel=0&showinfo=0&modestbranding=1`;
		});
	});
};
